document.addEventListener("DOMContentLoaded", function () {
    const submenuDiv = document.querySelector(".sub-menu-div");

    if (!submenuDiv) return; // Exit if no submenu exists

    // Enable scrolling only on mobile
    function enableMobileScroll() {
        if (window.innerWidth <= 768) {
            submenuDiv.style.overflowX = "auto";
            submenuDiv.style.whiteSpace = "nowrap";
            submenuDiv.style.scrollBehavior = "smooth";
            submenuDiv.style.display = "flex"; // Ensure horizontal layout
            submenuDiv.style.gap = "15px"; // Optional spacing between items
            submenuDiv.style.padding = "10px"; // Prevent items from sticking to edges
          //  submenuDiv.style.scrollbarWidth = "none"; // Hide scrollbar (Firefox)
            submenuDiv.style.msOverflowStyle = "none"; // Hide scrollbar (IE)
        } else {
            submenuDiv.style.overflowX = "unset";
        }
    }

    // Hide scrollbar for Webkit browsers (Chrome, Safari)
   // submenuDiv.style.cssText += `::-webkit-scrollbar { display: flex; }`;

    // Call function on load and resize
    enableMobileScroll();
    window.addEventListener("resize", enableMobileScroll);
});
